import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { Tag, Badge } from 'antd';
import dayjs from 'dayjs';
import './index.less';
import { oaTaskCount, oaTaskRunning, oaTaskCompleted, oaProcessMy, oaProcessCc } from '../../services';
import { PageContainer } from '@ant-design/pro-components';
import { FreeTable, useJumpPageRouteGet } from '@/shared';
import { summaryMap } from '@/shared/system/common/summaryMap';
const headers = {
    'depend-uri': '/api/activiti/v1/oa/task/running',
    'depend-method': 'POST',
};
const bq = {
    cost: '成本管理',
    purchase: '采购管理',
    contracting: '合同管理',
    pay: '工程款及发票',
    ant: '金融服务',
    quality: '质量管理',
    safe: '安全管理',
    safety: '安全管理',
    fee: '费用控制',
    construction: '施工管理',
    schedule: '进度管理',
    design: '设计管理',
    // 'project': '工程划分',
    project: '项目管理',
    payCenter: '卖家中心',
    mch: '卖家中心',
    mat: '物资管理',
    equip: '设备管理',
};
const mapList = (type) => {
    return {
        // 成本管理
        "cost1010": "成本管理",
        "cost1020": "成本管理",
        "cost1030": "成本管理",
        "cost1040": "成本管理",
        "cost1050": "成本管理",
        "cost1060": "成本管理",
        "cost1070": "成本管理",
        "cost1080": "成本管理",
        "cost2010": "成本管理",
        "cost2020": "成本管理",
        "cost2030": "成本管理",
        // crm
        'crm1010': '客户管理',
        'crm1020': '商机管理',
        'crm1210': '客户管理',
        'crm1220': '商机管理',
        'crm2020': '线索管理',
        'crm2040': '项目报备',
        'riskWarning1030_crm1040_1': 'CRM',
        'riskWarning1030_crm1040_2': 'CRM',
        'riskWarning1030_crm1040_3': 'CRM',
        'riskWarning1030_crm1040_4': 'CRM',
        // uims
        'uims1010': '企业运营',
        'uims4100': '我的团队',
        'common1000': '资源管理',
        'common1010': '价格管理',
        // scm
        'scm1010': '采购寻源',
        'scm1020': '采购寻源',
        'scm1030': '采购寻源',
        'scm1040': '合同协同',
        'scm1050': '合同协同',
        'scm1060': '交易协同',
        'scm1070': '交易协同',
        'scm1080': '协同单位',
        'scm1090': '协同单位',
        'scm2010': '鲁班物资管理',
        'scm2020': '鲁班物资管理',
        'scm2030': '合同协同',
        'scm3010': '合同协同',
        'scm3040': '交易协同',
        'scm3041': '账单协同',
        'scm3081': '资金往来',
        'scm3080': '资金往来',
        'scm3090': '发票协同',
        'scm3091': '发票协同',
        'scm3060': '交易协同',
        'scm3061': '交易协同',
        'scm3020': '交易协同',
        'scm3030': '交易协同',
        'scm3031': '结算协同',
        'scm3050': '交易协同',
        'scm3021': '交易协同',
        'scm2050': '协同单位',
        'scm4010': '基础管理',
        'scm4020': '基础管理',
        'settle1010': '资金往来',
        'settle1030': '结算协同',
        'settle1040': '账单协同',
        'settle1050': '结算协同',
        'settle1060': '发票协同',
        'settle1080': '结算协同',
        'settle1090': '资金往来',
        'settle2010': '发票协同',
        'logistic1010': '交易协同',
        'logistic1020': '交易协同',
        'logistic1030': '交易协同',
        'logistic1040': '交易协同',
        'logistic1050': '交易协同',
        'logistic1060': '交易协同',
        'task1100': '督查督办',
        'ls3000': '劳务点工',
        'ls4000': '机械台班',
        'psi1010': type == 1 ? '采购管理' : '销售管理',
        'psi1020': type == 1 ? '采购管理' : '销售管理',
        'psi1030': '销售管理',
        'psi1040': '采购管理',
        'psi1050': '销售管理',
        'psi1060': '采购管理',
        'psi2020': type == 1 ? '采购管理' : '销售管理',
        'psi-settle1010': '财务管理',
        'psi-settle1020': '财务管理',
        'psi-settle1030': '财务管理',
        'psi-settle1040': '财务管理',
        'psi-settle1050': '财务管理',
        'psi-settle1060': '财务管理',
        'psi-settle1070': '财务管理',
        'psi-settle1080': '财务管理',
        'psi-settle1090': '财务管理',
        // 'scm2010': '基础管理',
        'project1000': '基础管理',
    };
};
// const financeMap = {
//   'finance2000': '金融服务',
//   'finance4000': '金融服务'
// }
const tData = [
    { name: '待办', key: 0, num: 0 },
    { name: '已办', key: 1, num: 0 },
    { name: '我发起的', key: 4, num: 0 },
    { name: '抄送我的', key: 5, num: 0 }
];
const tabs = [
    { key: 0, tab: '待办' },
    { key: 1, tab: '已办' },
    { key: 4, tab: '我发起的' },
    { key: 5, tab: '抄送我的' },
];
/**
 * 获取待办任务类型的内容
 * @param businessCode 任务编码code
 * @param render 重写dom
 * @returns
 */
const getTagDom = (name) => _jsx(Tag, { color: 'blue', children: name });
export const getBusinessCodeTag = (businessCode, type, render) => {
    const mapKeys = mapList(type);
    const bName = mapKeys[businessCode];
    if (bName) {
        return render ? render(getTagDom(bName), bName) : getTagDom(bName);
    }
    // 去掉数字匹配
    const bqKeys = Object.keys(bq).find(key => (businessCode.replace(/[0-9]+$/, '')) == key);
    // 修改匹配逻辑：优先匹配完整的键，避免子字符串匹配问题
    const keys = businessCode.includes('-')
        ? Object.keys(mapKeys).find(key => key === businessCode)
        : Object.keys(mapKeys).find(key => (businessCode + '').includes(key));
    const name = (keys ? mapKeys[keys] : bqKeys ? bq[bqKeys] : null) || summaryMap[businessCode]?.({})?.systemName;
    const defaultDom = _jsx(Tag, { color: 'blue', children: name });
    return name ? render ? render(defaultDom, name) : defaultDom : '--';
};
export const Backlog = (props) => {
    const { module, tag, project, columns, isJoinBasePath, customParams, renderBusinessCode, tableProps, ...rest } = props;
    const companyId = sessionStorage.getItem('USER_INFO');
    const [tabCountMap, setTableCountMap] = useState({});
    const activeKeyRef = useRef(0);
    const actionRef = useRef();
    const [selectedTags, handleChange2] = useState(tag);
    const { getJumpPagePath } = useJumpPageRouteGet(headers);
    useEffect(() => { }, []);
    const formatTabNum = (num) => (num > 99 ? '99+' : num);
    const columns2 = [
        {
            title: '任务类型',
            dataIndex: 'businessCode',
            ellipsis: true,
            search: false,
            renderText: (_, recorde) => {
                if (renderBusinessCode) {
                    return renderBusinessCode(recorde);
                }
                const type = recorde.variables.type || null;
                return getBusinessCodeTag(recorde.businessCode, type);
            }
        },
        {
            title: '流程名称',
            dataIndex: 'processName',
            formItemProps: { label: '关键词', name: 'keyword' },
            fieldProps: { placeholder: '请输入流程名称或编号搜索' },
            ellipsis: true,
            renderText: (_, recorde) => {
                return _jsx("a", { onClick: () => {
                        acdetails(recorde);
                    }, children: recorde.processName || '--' }, recorde.id);
            }
        },
        {
            title: '编号',
            dataIndex: 'code',
            search: false,
            ellipsis: true,
        },
        ...(selectedTags == 1 || selectedTags == 4 ? [
            {
                title: '本单位流程状态',
                dataIndex: 'approveState',
                search: false,
                renderText: (_, record) => {
                    const approve = {
                        2: { label: '审批中', status: 'processing' },
                        3: { label: '审批通过', status: 'success' },
                        4: { label: '审批拒绝', status: 'error' }
                    };
                    if (record.approveState) {
                        return (_jsx(Badge, { status: approve[record.approveState].status, text: approve[record.approveState].label }));
                    }
                    else {
                        return '--';
                    }
                }
            }
        ] : []),
        {
            title: selectedTags == 0 ? '到达时间' : (selectedTags == 1 || selectedTags == 4) ? '发起时间' : '抄送时间',
            dataIndex: 'createTime',
            valueType: 'dateTimeRange',
            search: false,
            ellipsis: true,
            render: (_, record) => {
                if (record.createTime) {
                    return dayjs(record.createTime).format('YYYY-MM-DD HH:mm:ss');
                }
                else {
                    return '--';
                }
            }
        }
    ];
    const acdetails = (row) => {
        getJumpPagePath(row, {
            oaMode: true,
            returnJumpResponseAll: isJoinBasePath,
            ...(customParams ?? {})
        }).then((directPath) => {
            if (props?.acquiredetails) {
                props?.acquiredetails(row, directPath);
            }
            else {
                if (directPath) {
                    window.location.href = directPath;
                }
            }
        });
    };
    return (_jsx(PageContainer, { className: 'PageContainerBox', children: _jsx(FreeTable, { className: 'freeTableClass', columns: columns ? columns : columns2, actionRef: actionRef, rowKey: "id", columnEmptyText: '--', ...tableProps, request: async (params) => {
                const { current, pageSize, keyword } = params;
                console.log(params);
                const postdata = {
                    module: module,
                    keyword: keyword || '',
                    pageSize: pageSize,
                    pageNum: current,
                    companyId: JSON.parse(companyId).defaultCompId,
                };
                const par = {
                    module: module,
                    companyId: JSON.parse(companyId).defaultCompId,
                    keyword: keyword || '',
                };
                const rdata = await oaTaskCount(par);
                const map = (rdata.data || []).reduce((a, { type, num }) => ((a[type] = num), a), {});
                setTableCountMap(map);
                let req = null;
                // 待办
                console.log(activeKeyRef.current);
                if (activeKeyRef.current == 0) {
                    req = await oaTaskRunning(postdata);
                }
                else if (activeKeyRef.current == 1) {
                    req = await oaTaskCompleted(postdata);
                }
                else if (activeKeyRef.current == 4) {
                    req = await oaProcessMy(postdata);
                }
                else if (activeKeyRef.current == 5) {
                    req = await oaProcessCc(postdata);
                }
                const { data, code } = req;
                if (code == 200 && data) {
                    if (data.rows && data.rows.length > 0) {
                        data.rows.forEach((item) => {
                            for (const key in item.variables) {
                                item[key] = item.variables[key];
                            }
                        });
                    }
                    return {
                        data: data.rows || [],
                        current: current,
                        success: true,
                        total: data.total,
                    };
                }
                else {
                    return { success: false };
                }
            }, toolbar: {
                multipleLine: true,
                tabs: {
                    onChange: (key) => {
                        activeKeyRef.current = key;
                        handleChange2(key);
                        actionRef.current?.reloadAndRest?.();
                    },
                    items: tabs.map(({ key, tab }) => ({
                        key,
                        tab: `${tab} ${tabCountMap[key] ? `(${formatTabNum(tabCountMap[key])})` : ''}`,
                    })),
                },
            } }) }));
};
Backlog.defaultProps = {
    project: true,
    isJoinBasePath: false
};
